import LabServiceCollection from "@/collections/LabServiceCollection";
import ResultExportModel from "@/models/lab/ResultExportModel";

export default class ResultExportCollection extends LabServiceCollection {

  model() {
    return ResultExportModel;
  }

}
